export const GET_LIVE_DATA = 'GET_LIVE_DATA';// 查询直播配置列表
export const GET_LIVE_DETAIL = 'GET_LIVE_DETAIL';// 查询直播配置详情
export const CREATE_LIVE = 'CREATE_LIVE';// 新增直播配置
export const UPDATE_LIVE = 'UPDATE_LIVE';// 编辑直播配置
export const DELETE_LIVE = 'DEL_ACTIVITY';// 删除直播
